import { Box, Tooltip, useDisclosure } from "@chakra-ui/react";
import React, { useState } from "react";

/**
 * @description 此功能是為了在觸摸設備上提供一個可點擊的 Tooltip。
 * 在桌面設備上，Tooltip 會在鼠標懸停時顯示。
 * 在觸摸設備上，Tooltip 會在點擊時顯示。
 * @param {*} label - Tooltip 的內容。
 * @param {*} children - 包裹 Tooltip 的子元素。
 * @example
 * <TooltipWithTouch label="這是一個提示">
 *      <Button>點擊我</Button>
 * </TooltipWithTouch>
 *
 * @returns JSX.Element
 */
const TooltipWithTouch = ({ label, children, boxClassName } = {}) => {
  const { isOpen, onOpen, onToggle, onClose } = useDisclosure();

  return (
    <Tooltip isOpen={isOpen} label={label}>
      <Box
        {...boxClassName}
        onMouseEnter={onOpen}
        onMouseLeave={onClose}
        onClick={onToggle}
      >
        {children}
      </Box>
    </Tooltip>
  );
};

export default TooltipWithTouch;
